/**
 * Field length limits, shared by the server that enforces them and the forms
 * that should stop a person from ever hitting them. Kept in one pure module so
 * a form cannot drift from the rule it is previewing.
 */

export const PROFILE_LIMITS = {
  name: 100,
  headline: 120,
  bio: 2000,
  location: 100,
  phone: 20,
  url: 300,
  freeText: 120,
  skillCount: 30,
  experienceCount: 15,
  educationCount: 10,
  entryDescription: 1000,
} as const

export const COMPANY_LIMITS = {
  name: 100,
  oneLiner: 120,
  about: 2000,
  location: 100,
  freeText: 120,
} as const

/** One formatter for both the form's counter and the server's message. */
export function formatCount(count: number) {
  return String(count).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

/**
 * "About must be 2000 characters or fewer" leaves a person counting a pasted
 * block by hand. Say how long theirs is and how much has to go.
 */
export function overLimitMessage(label: string, length: number, max: number) {
  return `${label} is ${formatCount(length)} characters. Remove ${formatCount(
    length - max,
  )} to fit the ${formatCount(max)} limit.`
}
